module.exports = __webpack_public_path__ + "img/48.9e2e8da1.png";